module.exports = __webpack_public_path__ + "static/media/lp_self.4fd64570.svg";